// Opera 8.0+
export const isOpera =
  typeof window !== 'undefined' &&
  window &&
  (!!window.opr || !!window.opera || navigator.userAgent.indexOf(' OPR/')) >= 0;

// Firefox 1.0+
export const isFirefox = typeof InstallTrigger !== 'undefined';

// Safari 3.0+ "[object HTMLElementConstructor]"
export const isSafari =
  typeof window !== 'undefined' &&
  window &&
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

// Internet Explorer 6-11
export const isIE =
  /* @cc_on!@ */ false ||
  (typeof document !== 'undefined' && document && !!document.documentMode);

// Edge 20+
export const isEdge =
  !isIE && typeof window !== 'undefined' && window && !!window.StyleMedia;

// Chrome 1 - 79
export const isChrome =
  typeof window !== 'undefined' &&
  window &&
  !!window.chrome &&
  (!!window.chrome.webstore || !!window.chrome.runtime);

// Edge (based on chromium) detection
export const isEdgeChromium =
  isChrome && navigator.userAgent.indexOf('Edg') !== -1;

// Blink engine detection
export const isBlink =
  (isChrome || isOpera) &&
  typeof window !== 'undefined' &&
  window &&
  !!window.CSS;
export const fnBrowserDetect = () => {
  const { userAgent } = navigator;
  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = 'chrome';
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = 'firefox';
  } else if (userAgent.match(/safari/i)) {
    browserName = 'safari';
  } else if (userAgent.match(/opr\//i)) {
    browserName = 'opera';
  } else if (userAgent.match(/edg/i)) {
    browserName = 'edge';
  } else {
    browserName = 'No browser detection';
  }

  return browserName;
};
